module.exports = __webpack_public_path__ + "static/Lato-Semibold-3b0cd7254b3b6ddb8a313d41573fda8b.ttf";